import { NgModule } from '@angular/core';
import { UiCommonModule } from '@widgets/ui-common/ui.common.module';
import { StatusOverviewComponent } from '@widgets/site-common/status-overview/status-overview.component';
import { SegmentComponent } from '@widgets/site-common/status-overview/segment/segment.component';
import { SegmentLegendItemComponent } from './segment-legend-item/segment-legend-item.component';

@NgModule({
  declarations: [StatusOverviewComponent, SegmentComponent, SegmentLegendItemComponent],
  imports: [UiCommonModule],
  exports: [StatusOverviewComponent, SegmentComponent]
})
export class StatusOverviewModule {}
